/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API SSO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetYandexClientIdByUserIdRequestDto } from '../models';
// @ts-ignore
import type { SetYandexClientIdDto } from '../models';
// @ts-ignore
import type { YandexClientIdDto } from '../models';
/**
 * YANDEXApi - axios parameter creator
 * @export
 */
export const YANDEXApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение clientId от Yandex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yandexControllerGetMeYandexClientId: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/yandex/getMeYandexClientId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение clientId от Yandex по userId
         * @param {GetYandexClientIdByUserIdRequestDto} getYandexClientIdByUserIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yandexControllerGetYandexClientIdByUserId: async (getYandexClientIdByUserIdRequestDto: GetYandexClientIdByUserIdRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getYandexClientIdByUserIdRequestDto' is not null or undefined
            assertParamExists('yandexControllerGetYandexClientIdByUserId', 'getYandexClientIdByUserIdRequestDto', getYandexClientIdByUserIdRequestDto)
            const localVarPath = `/yandex/getYandexClientIdByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getYandexClientIdByUserIdRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Добавление clientId от Yandex
         * @param {SetYandexClientIdDto} setYandexClientIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yandexControllerSetYandexClientId: async (setYandexClientIdDto: SetYandexClientIdDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setYandexClientIdDto' is not null or undefined
            assertParamExists('yandexControllerSetYandexClientId', 'setYandexClientIdDto', setYandexClientIdDto)
            const localVarPath = `/yandex/setYandexClientId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "apiKey", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setYandexClientIdDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * YANDEXApi - functional programming interface
 * @export
 */
export const YANDEXApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = YANDEXApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получение clientId от Yandex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yandexControllerGetMeYandexClientId(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YandexClientIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yandexControllerGetMeYandexClientId(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YANDEXApi.yandexControllerGetMeYandexClientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение clientId от Yandex по userId
         * @param {GetYandexClientIdByUserIdRequestDto} getYandexClientIdByUserIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yandexControllerGetYandexClientIdByUserId(getYandexClientIdByUserIdRequestDto: GetYandexClientIdByUserIdRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<YandexClientIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yandexControllerGetYandexClientIdByUserId(getYandexClientIdByUserIdRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YANDEXApi.yandexControllerGetYandexClientIdByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Добавление clientId от Yandex
         * @param {SetYandexClientIdDto} setYandexClientIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async yandexControllerSetYandexClientId(setYandexClientIdDto: SetYandexClientIdDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.yandexControllerSetYandexClientId(setYandexClientIdDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['YANDEXApi.yandexControllerSetYandexClientId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * YANDEXApi - factory interface
 * @export
 */
export const YANDEXApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = YANDEXApiFp(configuration)
    return {
        /**
         * 
         * @summary Получение clientId от Yandex
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yandexControllerGetMeYandexClientId(options?: RawAxiosRequestConfig): AxiosPromise<YandexClientIdDto> {
            return localVarFp.yandexControllerGetMeYandexClientId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение clientId от Yandex по userId
         * @param {GetYandexClientIdByUserIdRequestDto} getYandexClientIdByUserIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yandexControllerGetYandexClientIdByUserId(getYandexClientIdByUserIdRequestDto: GetYandexClientIdByUserIdRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<YandexClientIdDto> {
            return localVarFp.yandexControllerGetYandexClientIdByUserId(getYandexClientIdByUserIdRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Добавление clientId от Yandex
         * @param {SetYandexClientIdDto} setYandexClientIdDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        yandexControllerSetYandexClientId(setYandexClientIdDto: SetYandexClientIdDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.yandexControllerSetYandexClientId(setYandexClientIdDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * YANDEXApi - object-oriented interface
 * @export
 * @class YANDEXApi
 * @extends {BaseAPI}
 */
export class YANDEXApi extends BaseAPI {
    /**
     * 
     * @summary Получение clientId от Yandex
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YANDEXApi
     */
    public yandexControllerGetMeYandexClientId(options?: RawAxiosRequestConfig) {
        return YANDEXApiFp(this.configuration).yandexControllerGetMeYandexClientId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение clientId от Yandex по userId
     * @param {GetYandexClientIdByUserIdRequestDto} getYandexClientIdByUserIdRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YANDEXApi
     */
    public yandexControllerGetYandexClientIdByUserId(getYandexClientIdByUserIdRequestDto: GetYandexClientIdByUserIdRequestDto, options?: RawAxiosRequestConfig) {
        return YANDEXApiFp(this.configuration).yandexControllerGetYandexClientIdByUserId(getYandexClientIdByUserIdRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Добавление clientId от Yandex
     * @param {SetYandexClientIdDto} setYandexClientIdDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof YANDEXApi
     */
    public yandexControllerSetYandexClientId(setYandexClientIdDto: SetYandexClientIdDto, options?: RawAxiosRequestConfig) {
        return YANDEXApiFp(this.configuration).yandexControllerSetYandexClientId(setYandexClientIdDto, options).then((request) => request(this.axios, this.basePath));
    }
}

